import React from 'react';
import Mission from '../../components/Mission';
import MainSection from '../../components/Layout';

import { Box } from '@mui/material';

const About = () => {
  return (
    <Box>
      <MainSection />
      <Mission />
    </Box>
  );
};

export default About;
